import { LocationConfiguration } from "#/models/location-configuration";
import { create } from "zustand";

type LocationConfigurationStoreType = {
  locationConfiguration?: LocationConfiguration;
  setLocationConfiguration: (configuration: LocationConfiguration) => void;
};

const useLocationConfigurationStore = create<LocationConfigurationStoreType>(
  (set) => ({
    locationConfiguration: undefined,
    setLocationConfiguration: (configuration: LocationConfiguration) =>
      set({ locationConfiguration: configuration }),
  })
);

export default useLocationConfigurationStore;
